import { render, staticRenderFns } from "./PlansDialog.vue?vue&type=template&id=04ce2ac3&scoped=true&"
import script from "./PlansDialog.vue?vue&type=script&lang=js&"
export * from "./PlansDialog.vue?vue&type=script&lang=js&"
import style0 from "./PlansDialog.vue?vue&type=style&index=0&id=04ce2ac3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce2ac3",
  null
  
)

export default component.exports